var riot = require("riot");


riot.tag2('ahv-help-display', '<div id="ahv-help-display" style="display: none"> <div id="ahv-help-display-title"> Hjelpetekst </div> <div id="ahv-help-display-text"> Innholdet kommer her </div> </div>', '', '', function(opts) {
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/helpDisplay/ahv-help-display.tag
 ** module id = 87
 ** module chunks = 0
 **/